export default __webpack_public_path__ + "static/media/success.05c28e78.svg";